import { IconButton, OutlinedInputProps, Skeleton } from "@mui/material";
import Button from "@mui/material/Button";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import UploadIcon from "@mui/icons-material/Upload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { Dayjs } from "dayjs";
import { Input } from "../../../../../components/Input/input";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Stack } from "@mui/system";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  emptyString,
  expectedFileInsurance,
  insuranceToDate,
  unloadedFile,
} from "../../text";
import { dateFormating } from "../../../operator-orders-offering/helpers";
import { useMutation } from "@tanstack/react-query";
import { addWarehousesInsurance } from "../../../../../services/warehouses-insurance/add";
import { urlOperator } from "../../../../../utils/url";
import { useNavigate } from "react-router";

interface UploadFormProps {
  magazyn_id: string;
  fieldValue: File | null;
  fileIsLoading?: boolean;
  insuranceAdded: boolean;
  setFieldValue: (fildValue: File | null) => void;
  setFileIsLoading: (fileIsLoading: boolean) => void;
  setInsuranceAdded: (value: boolean) => void;
}

export const UploadForm = ({
  magazyn_id,
  fieldValue,
  insuranceAdded,
  setFieldValue,
  setFileIsLoading,
  setInsuranceAdded,
}: UploadFormProps) => {
  const navigate = useNavigate();

  const [insuranceDate, setInsuranceDate] = useState<Dayjs | null>();
  const [labelAddedFile, setLabelAddedFile] = useState(
    fieldValue?.name ? fieldValue.name : emptyString
  );
  const [addedFile, setAddedFile] = useState(false);
  const [addedDate, setAddedDate] = useState(false);
  const [errMessage, setErrMessage] = useState(false);
  const [errPdfMessage, setErrPdfMessage] = useState(false);

  const handleAddFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    let isPdf: Boolean =
    e.target.files?.[0]?( e.target.files?.[0].type === "application/pdf" ? true : false):false;
    formik.handleChange(e);
    setLabelAddedFile(
      isPdf
        ? e.target.files?.[0]
          ? e.target?.files[0].name
          : emptyString
        : emptyString
    );
    setFieldValue(
      isPdf ? (e.target.files?.[0] ? e.target?.files[0] : null) : null
    );
    setAddedFile(isPdf ? (e.target.files?.[0] ? true : false) : false);
    setErrPdfMessage(isPdf ? false : true);
  };

  const handleCancel = () => {
    setFileIsLoading(false);
    setFieldValue(null);
    setAddedFile(false);
    setErrPdfMessage(false);
  };

  const addWarehousesInsuranceMutation = useMutation(addWarehousesInsurance, {
    onSuccess: (res) => {
      setInsuranceAdded(true);
      handleCancel();
      navigate(urlOperator.subcontractors);
    },
    onError: (err: any) => {},
  });

  const formik = useFormik({
    initialValues: {
      dataInsurance: insuranceDate,
    },

    onSubmit: (values) => {
      handleUpload();
    },
  });

  const handleUpload = () => {
    fieldValue
      ? addWarehousesInsuranceMutation.mutate({
          MagazynId: magazyn_id,
          DataZakonczenia: `${dateFormating(
            insuranceDate ? insuranceDate : new Date()
          )}Z`,
          Polisa: fieldValue,
        })
      : handleCancel();
  };

  if (addWarehousesInsuranceMutation.isLoading) {
    return (
      <Stack spacing={1}>
        <Skeleton variant="rounded" width={260} height={53} />
        <Skeleton variant="rounded" width={260} height={37} />
      </Stack>
    );
  }
  return (
    <UploudWrapper>
      <FormInsuranceAdd onSubmit={formik.handleSubmit}>
        <FormWrapper>
          <ButtonLoadingWrapper>
            <FileLabel isFileAdded={addedFile}>
              {labelAddedFile === emptyString
                ? errPdfMessage
                  ? expectedFileInsurance
                  : unloadedFile
                : `${labelAddedFile}`}
            </FileLabel>
            <IconButton
              color="primary"
              aria-label="upload file"
              component="label"
              sx={{
                color: `${theme.colors.black_primaryText}`,
              }}
            >
              <input
                id="polisa"
                name="polisa"
                hidden
                accept="application/pdf"
                type="file"
                style={{ marginTop: "-10px" }}
                onChange={handleAddFile}
              />
              {labelAddedFile === emptyString ? (
                <UploadIcon />
              ) : (
                <AttachFileIcon
                  sx={{
                    color: "#008000",
                  }}
                />
              )}
            </IconButton>
          </ButtonLoadingWrapper>

          {labelAddedFile === emptyString ? null : (
            <LocalizationProvider
              //adapterLocale={pl}
              dateAdapter={AdapterDateFns}
            >
              <DatePickersWrapper>
                <DesktopDatePicker
                  views={["day"]}
                  label={insuranceToDate}
                  disablePast
                  value={insuranceDate}
                  InputProps={
                    { disableUnderline: true } as Partial<OutlinedInputProps>
                  }
                  onChange={(newValue) => {
                    setInsuranceDate(newValue);
                    setAddedDate(
                      newValue
                        ? dateFormating(newValue) !== dateFormating(new Date())
                          ? true
                          : false
                        : false
                    );
                  }}
                  renderInput={(params) => (
                    <InputWrapper>
                      <Input
                        {...params}
                        helperText={null}
                        variant="filled"
                        sx={{
                          width: "120px",
                          ".MuiInputBase-input": {
                            paddingLeft: "6px",
                            marginRight: "-12px",
                            fontSize: "14px",
                            ".MuiFilledInput-input": {},
                          },
                          ".MuiInputLabel-root": {
                            left: "-6px",
                            color: `${
                              addedDate
                                ? theme.colors.black_primaryText
                                : theme.colors.gray01_secondaryText
                            }`,
                          },
                          "MuiFormControl-root": {},
                          ".MuiFilledInput-root": {
                            borderRadius: "0px",
                            backgroundColor: "transparent",
                            color: `${
                              addedDate
                                ? "black"
                                : theme.colors.gray01_secondaryText
                            }`,
                            ":hover": {
                            //   color: `${theme.colors.blue01_active}`,
                              backgroundColor: "#d0d7de",
                            },
                          },
                          ".Mui-focused": {
                            backgroundColor: "#d0d7de",
                          },
                          ".MuiSvgIcon-root": {
                            color: `${
                              addedDate
                                ? "#008000"
                                : theme.colors.gray01_secondaryText
                            }`,
                          },
                        }}
                      />
                    </InputWrapper>
                  )}
                />
              </DatePickersWrapper>
            </LocalizationProvider>
          )}
        </FormWrapper>
        <ButtonsWrapper>
          <Button
            // variant="outlined"
            onClick={handleCancel}
            // sx={{
            //     width: `${addedDate && addedFile ? "50%" : "100%"}`,
            //   color: `${theme.colors.gray01_secondaryText}`,
            //   borderColor:`${theme.colors.gray05_input}`,
            //   ":hover, :active": {
            //     color: `${theme.colors.blue01_active}`,
            //     borderColor:`${theme.colors.blue01_active}`,
            //   },
            // }}
          >
            Anuluj
          </Button>
          {addedDate && addedFile ? (
            <Button 
            type="submit" 
            //variant="contained" 
            sx={{ width: "50%" }}>
              Zapisz
            </Button>
          ) : (
            <></>
          )}
        </ButtonsWrapper>
      </FormInsuranceAdd>
    </UploudWrapper>
  );
};
const UploudWrapper = styled.div``;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
`;
const FormInsuranceAdd = styled.form`
  width: 260px;
  margin: auto auto;
`;
const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
`;
const ButtonLoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: auto auto;
`;
const FileLabel = styled.div<{
  isFileAdded: boolean;
}>`
  ${(props: any) =>
    props.isFileAdded
      ? `
       font-size:12px;
       color:black;
       padding-top:18px;
       width:87px;
    //    paddinf-left:-30px;
       
        `
      : `
       justify-content: center;
       font-size:14px;
       color:${theme.colors.black_primaryText};
       padding-top:8px;

         
      `};
  hite-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 8px;
`;
const InputWrapper = styled.div`
  width: 120px;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  justify-content: space-between;
`;
const SkeletorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gup: 10px;
  background-wrapper: red;
`;
// export const ButtonMessageCancel = styled.div`
//   color: #1976d2;
// `;
